import React from 'react';
import LegalPage from './LegalPage';

const DisclaimerPage = () => {
  return (
    <LegalPage title="Disclaimer" slug="disclaimer" lastUpdated="January 2026">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">1. General Disclaimer</h2>
        <p className="text-zinc-700 leading-relaxed">
          The information provided on Indicraft is for general informational purposes only. While we strive to ensure accuracy, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, or availability of the website or the products listed.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">2. Product Information</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">
          Product descriptions, specifications, and images are provided by manufacturers and suppliers. While we make every effort to display accurate information:
        </p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li>Actual product colors may vary slightly due to screen settings</li>
          <li>Product dimensions and specifications are approximate</li>
          <li>Features and accessories may differ from descriptions</li>
          <li>Packaging may change without notice</li>
          <li>We are not liable for any discrepancies in product information</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">3. Use at Your Own Risk</h2>
        <p className="text-zinc-700 leading-relaxed">
          Your use of Indicraft and reliance on any information is at your own risk. We do not guarantee that the website will be available at all times, error-free, or free from viruses or other harmful components.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">4. Third-Party Links</h2>
        <p className="text-zinc-700 leading-relaxed">
          Our website may contain links to third-party websites for your convenience. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites. We do not endorse or recommend any third-party products or services.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">5. Professional Advice</h2>
        <p className="text-zinc-700 leading-relaxed">
          The content on our website is not intended to be a substitute for professional advice. Always seek the advice of qualified professionals regarding any questions you may have about product use, safety, or compatibility.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">6. Pricing and Availability</h2>
        <p className="text-zinc-700 leading-relaxed">
          Prices and availability of products are subject to change without notice. While we make every effort to ensure pricing accuracy, errors may occur. In case of pricing errors, we reserve the right to cancel orders or request additional payment.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">7. Limitation of Liability</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">
          Indicraft and its affiliates shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages resulting from:
        </p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li>Your use or inability to use the website</li>
          <li>Unauthorized access to your personal information</li>
          <li>Any errors or omissions in website content</li>
          <li>Product defects or quality issues</li>
          <li>Delays or failures in delivery</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">8. Product Warranty</h2>
        <p className="text-zinc-700 leading-relaxed">
          Product warranties are provided by manufacturers, not by Indicraft. For warranty claims, please contact the manufacturer directly. We facilitate the process but are not responsible for warranty fulfillment.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">9. Changes to Disclaimer</h2>
        <p className="text-zinc-700 leading-relaxed">
          We reserve the right to update this disclaimer at any time without notice. Continued use of the website after changes constitutes acceptance of the modified disclaimer.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">10. Force Majeure</h2>
        <p className="text-zinc-700 leading-relaxed">
          We shall not be liable for any failure or delay in performance due to circumstances beyond our reasonable control, including natural disasters, war, terrorism, pandemics, labor disputes, or government actions.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">11. Contact Information</h2>
        <p className="text-zinc-700 leading-relaxed">
          If you have questions about this disclaimer:<br />
          Email: legal@indicraft.in<br />
          Phone: +91 123-456-7890<br />
          Address: 123 Business Park, Mumbai, Maharashtra 400001, India
        </p>
      </section>
    </LegalPage>
  );
};

export default DisclaimerPage;
